import { cn } from '@/lib/helpers/utils';
import { Bookmark as BookmarkIcon } from 'lucide-react';
import React from 'react';
import { EntityCardType } from '../../types/cards';
import { ContentType } from '../../types/content';
import { NotificationToastBookmarkEntityMessages } from '../layout/notification-toast/NotificationToastBookmarkEntityMessages';
import Bookmark, { BookmarkProps } from './Bookmark';

interface SaveProps extends Partial<BookmarkProps> {
  contentType: ContentType | EntityCardType;
}

/**
 * @return {JSX}
 */
const Save = React.forwardRef<HTMLButtonElement, SaveProps>(
  (
    {
      id,
      bookmarkBtnId,
      showToast,
      trackName = 'bookmark',
      trackAbacus = 'bookmark',
      callback,
      customHtml,
      icon = false,
      size = icon ? 'xs' : 'sm',
      variant = 'outline',
      appearance = icon ? 'gray' : 'primary',
      className,
      contentType
    },
    ref
  ) => {
    let message: any = '';
    if (!customHtml && contentType in NotificationToastBookmarkEntityMessages) {
      message = (NotificationToastBookmarkEntityMessages as any)[contentType as any];
    }
    const bookmarkLabel = 'Save';
    const bookmarkedLabel = 'Saved';

    return (
      <Bookmark
        ref={ref}
        id={id as string}
        bookmarkLabel={bookmarkLabel}
        bookmarkedLabel={bookmarkedLabel}
        trackName={trackName}
        trackAbacus={trackAbacus}
        showToast={showToast}
        bookmarkBtnId={bookmarkBtnId as string}
        customHtml={message}
        callback={callback}
        size={size}
        variant={variant}
        appearance={appearance}
        icon={icon}
        className={cn(icon ? 'min-w-8 min-h-8' : '', className)}
        contentType={contentType as string}
        data-cy={'button:save'}
      >
        {(bookmarked: boolean) => {
          return (
            <>
              {bookmarked ? (
                <BookmarkIcon fill="currentColor" className={'w-4 text-primary'} strokeWidth={1.5} />
              ) : (
                <BookmarkIcon className={'w-4 hover:text-primary'} strokeWidth={1.5} />
              )}
              <span className={icon ? 'sr-only' : ''}>{bookmarked ? bookmarkedLabel : bookmarkLabel}</span>
            </>
          );
        }}
      </Bookmark>
    );
  }
);

export default Save;
